import { render, staticRenderFns } from "./BillingAddress2.vue?vue&type=template&id=2439b9d3&scoped=true"
import script from "./BillingAddress2.vue?vue&type=script&lang=js"
export * from "./BillingAddress2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2439b9d3",
  null
  
)

export default component.exports